import favLogo from '../assets/images/favicon.png';
import acc from '../assets/images/favIcons/acc.png';
import aha from '../assets/images/favIcons/aha.png';
import pubmed from '../assets/images/favIcons/pubmed.png';
import chest from '../assets/images/favIcons/chest.png';
import process from 'node:process';

export const extractDomain = (url: string) => {
  try {
    const hostname = new URL(url).hostname;
    return hostname.replace(/^www\./, '');
  } catch (error) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.error('Error extracting domain:', error);
    }
    return url;
  }
};
export const getFavIcon = (url: string) => {
  if (!url) return '';
  if (url.includes('genio')) {
    return favLogo;
  }
  // Use custom favicon for ACC website
  if (url.includes('acc.org') || extractDomain(url) === 'acc.org') {
    return acc;
  }
  // Use custom favicon for AHA website
  if (url.includes('ahajournals.org') || extractDomain(url) === 'ahajournals.org') {
    return aha;
  }
  // Use custom favicon for pubmed website
  if (url.includes('pmc.ncbi.nlm.nih.gov') || extractDomain(url) === 'pmc.ncbi.nlm.nih.gov') {
    return pubmed;
  }
  // Use custom favicon for chest website
  if (url.includes('journal.chestnet.org') || extractDomain(url) === 'journal.chestnet.org') {
    return chest;
  }
  return `https://www.google.com/s2/favicons?sz=32&domain=${extractDomain(url)}`;
};
